<template>
  <div class="trade-offline-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="支付订金" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="trade-offline-detail-form">
      <div class="input-group">
        <div class="input-label">商家名称</div>
        <input class="mint-field-core form-input" v-model="shopInfo.name" readonly="readonly">
      </div>
      <div class="input-group">
        <div class="input-label">联系人</div>
        <input class="mint-field-core form-input" type="text" v-model="name" placeholder="请输入联系人  ">
      </div>
      <div class="input-group">
        <div class="input-label">联系电话</div>
        <input class="mint-field-core form-input" type="number" v-model="phone" placeholder="请输入联系电话">
      </div>
      <div class="input-group">
        <div class="input-label">收货地址</div>
        <input class="mint-field-core form-input" type="text" v-model="receiveAddress" placeholder="请输入收货地址">
      </div>
      <div class="input-group">
        <div class="input-label">订金金额 <span class="reduce-tip">(付订立减)</span></div>
        <input class="mint-field-core form-input" type="number" v-model="depositMoney" placeholder="请输入订金金额">
      </div>
      <div class="input-group">
        <div class="input-label">买家留言</div>
        <input class="mint-field-core form-input" type="text" v-model="message" placeholder="请输入您想对商家说的话">
      </div>
      <div class="input-group">
        <div class="input-label">备注</div>
        <input class="mint-field-core form-input" type="text" v-model="remarks" placeholder="订单备注">
      </div>
      <div class="trade-amount-info">
        <div v-if="activity.discount" class="input-group">
          <div class="input-label">水木家装团购补贴优惠</div><div class="amount-info-value">-¥{{activity.discount}}</div>
        </div>
        <div class="payable-amount">实际支付金额  <span class="amount-info-value">¥ <span class="value">{{deposit}}</span></span><span class="reduce-tip">(随机立减)</span></div>
      </div>
      <div class="form-btn" @click="payTraderOffline" v-if="!isPay">提交并支付</div>
      <div class="form-btn" v-if="isPay" @click="toTradeOfflineList">去查看支付结果</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import payUtil from '../../utils/Pay'
  import tradeOfflineService from '../../service/trade/TradeOfflineService'
  import customerAddressService from '../../service/customer/CustomerAddressService'
  import dealerShopService from '../../service/shop/ShopService'

  export default {
    name: 'OfflineDeposit',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        errorMsg:'',
        prePayInfo:{},
        shopId:'',
        activityId:'',
        type:'3',
        activity:{},
        shopInfo:{},
        promotionList:[],
        isCancelOffline:false,
        isPayOffline:false,
        name:'',
        phone:'',
        receiveAddress:'',
        depositMoney:'',
        deposit:0,
        message:'',
        remarks:'',
        discount:0,
        addressId:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isPay:false,
      }
    },
    created(){
      this.shopId = this.$route.query.shopId;
      this.activityId = this.$route.query.activityId;
      this.type = this.$route.query.type;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCustomerDefaultAddress();
      this.getShopPromotionList();
    },
    watch:{
      depositMoney(value){
        this.deposit = value - this.discount;
      }
    },
    methods: {
      async getCustomerDefaultAddress(){
        let {code,msg,data} = await customerAddressService.getDefault();
        if(code == '0'){
          this.addressId = data.id;
          this.name = data.receiver;
          this.phone = data.phone;
          this.receiveAddress = data.address;
        }else {
          Toast(msg);
        }
      },
      async getShopPromotionList(){
        let {code,msg,data} = await dealerShopService.promotionList(this.shopId,this.activityId);
        if(code == '0'){
          this.shopInfo = data.shop;
          this.activity = data.activity || {discount:0};
          this.discount = this.activity.discount;
          this.promotionList = data.promotions;
        }else {
          Toast(msg);
        }
      },
      async payTraderOffline(){
        if(!this.name){
          Toast('请输入联系人姓名!');
          return false;
        }
        if(!this.phone){
          Toast('请输入联系电话!');
          return false;
        }
        let re= /^1[3578]\d{9}$/;
        if(!re.test(this.phone)){
          Toast('您输入的手机号码有误,请重新输入!');
          return false;
        }
        if(!this.receiveAddress){
          Toast('请输入收货地址');
          return false;
        }
        var reg = /^(([1-9]\d*)|0)(\.\d{1,2})?$/;
        if(!this.depositMoney){
          Toast('请输入订金金额');
          return false;
        }else if(!reg.test(this.depositMoney)){
          Toast('请输入正确的订金金额');
          return false;
        }else if(parseFloat(this.depositMoney) <= this.discount){
          Toast('订金金额必须大于抵扣金额');
          return false;
        }
        let tradeOfflineFormData = {offlineType:this.type,shopId:this.shopId,deposit:this.deposit,name:this.name,
          phone:this.phone,receiveAddress:this.receiveAddress,addressId:this.addressId,message:this.message,remarks:this.remarks};
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          tradeOfflineFormData.browserType = '1';
          let result = await tradeOfflineService.saveAndPayOrder(tradeOfflineFormData);
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          tradeOfflineFormData.browserType = '2';
          let result = await tradeOfflineService.saveAndPayOrder(tradeOfflineFormData);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,
              "timeStamp":prePayInfo.timeStamp,
              "nonceStr":prePayInfo.nonceStr,
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,
              "paySign":prePayInfo.paySign
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.isPay = true;
                that.$router.push({name:'TradeOfflineList'});
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      toTradeOfflineList(){
        this.$router.push({name:'TradeOfflineList'});
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-offline-detail-page {
    padding-top: 0.05rem;
    background: white;
    color: #191818;
    font-size: 0.32rem;
    .trade-offline-detail-form{
      padding-bottom: 1rem;
      .trade-amount-info{
        margin-top: 0.2rem;
        padding-top: 0;
      }
      .input-group{
        height: 0.96rem;
        display: block;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #e0dedc;
        .input-label{
          width: auto;
          margin-top: 0.3rem;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          color: #7f7d7c;
        }
        .form-input{
          width: 6.9rem;
          height: 0.5rem;
          margin: 0 auto;
          line-height: 0.69rem;
          font-size: 0.32rem;
          background-color: white;
        }
      }
      .reduce-tip{
        margin-left: 0.1rem;
        font-weight: 500;
        color: #feac00;
      }
    }
  }
</style>
